import { render, staticRenderFns } from "./wxwkp.vue?vue&type=template&id=7a3a0a20&scoped=true&"
import script from "./wxwkp.vue?vue&type=script&lang=js&"
export * from "./wxwkp.vue?vue&type=script&lang=js&"
import style0 from "./wxwkp.vue?vue&type=style&index=0&id=7a3a0a20&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3a0a20",
  null
  
)

export default component.exports